import {
  Directive,
  Input,
  Output,
  EventEmitter,
  ElementRef
} from '@angular/core';

import { ScrollService } from './services/scroll/scroll.service';


@Directive({
  selector: '[appScrollSpy]'
})
export class ScrollSpyDirective {
  @Input() spiedTags: string[] = [];
  @Output() sectionChange = new EventEmitter<string>();
  private currentSection: string;

  constructor(
    private _el: ElementRef,
    private scrollService: ScrollService
  ) {
    scrollService.windowScroll.subscribe(e => {
      this.onScroll(e);
    })
  }

  onScroll(event: any) {
    let currentSection: string;
    let lastSpiedSection: string;
    const children = this._el.nativeElement.children;
    const scrollTop = event.target.scrollTop;
    const parentOffset = event.target.offsetTop;
    for (const element of children) {
      if (this.spiedTags.includes(element.tagName)) {
        lastSpiedSection = element.id;
        if ((element.offsetTop - parentOffset) <= scrollTop) {
          currentSection = element.id;
        }
      }
    }

    // The final section's heading may never scroll all the way to the top of
    // the container when its own content is shorter than the viewport, so the
    // check above would never mark it active. When the container is scrolled to
    // the bottom, treat the last spied section as the current one so it still
    // highlights (and so its nav link lands on a highlighted section).
    const isScrollable = event.target.scrollHeight > event.target.clientHeight;
    const isAtBottom =
      (event.target.scrollHeight - scrollTop - event.target.clientHeight) < 2;
    if (isScrollable && isAtBottom && lastSpiedSection) {
      currentSection = lastSpiedSection;
    }

    if (currentSection !== this.currentSection) {
      this.currentSection = currentSection;
      this.sectionChange.emit(this.currentSection);
    }
  }
}
